import { createContext } from 'react';

import { DEFAULT_MIN_RANGE_VALUE } from '../constants.js';

export const GaugeChartRangeMinContext = createContext<number>(
  DEFAULT_MIN_RANGE_VALUE,
);
